<template>
  <div
    v-if="title || subtitle"
    :id="renderId ? textToTarget(title, 'heading-2') : undefined"
    class="mb-16 flex flex-col"
    :class="center ? 'items-center' : 'md:items-baseline'"
  >
    <h2
      :id="titleId"
      class="text-static-default-hi heading-2"
      :class="{ 'mb-8 md:mb-0 md:mr-12': subtitle }"
    >
      {{ title }}
    </h2>
    <span class="text-static-default-low body-1">
      {{ subtitle }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { HeadingSize } from '@backmarket/http-api/src/api-specs-content/shared/heading-size'
import type { Maybe } from '@backmarket/utils/types/Maybe'

import { textToTarget } from '@backmarket/nuxt-layer-cms/utils/textToTarget'

withDefaults(
  defineProps<{
    titleId?: string
    title?: Maybe<string>
    subtitle?: Maybe<string>
    center?: boolean
    headingSize?: Maybe<HeadingSize>
    renderId?: boolean
  }>(),
  {
    titleId: undefined,
    title: '',
    subtitle: '',
    center: false,
    headingSize: 'medium',
    renderId: true,
  },
)
</script>
